import { useState } from 'react'
import BrowseByCategory from '../BrowserByCategory'
import CardList from '../CardList'
import { StyledTileContainer, StyledTileHeader, StyledTileMore, StyledTileTitle } from './TileStyle'

const renderTitle = (tileData, setSelectedCategory) => {
  return (
    <>
      {tileData?.title && (
        <StyledTileTitle
          nopointer={tileData?.itemType === 'category'}
          onClick={() => {
            if (tileData?.itemType !== 'category') {
              setSelectedCategory(true)
            }
          }}
        >
          {tileData?.title}
        </StyledTileTitle>
      )}
      {!tileData?.title && tileData?.altText && (
        <StyledTileTitle
          nopointer={tileData?.itemType === 'category'}
          onClick={() => {
            if (tileData?.itemType !== 'category') {
              setSelectedCategory(true)
            }
          }}
        >
          {tileData?.altText}
        </StyledTileTitle>
      )}
    </>
  )
}

const renderMore = (tileData, setSelectedCategory) => {
  return (
    tileData?.showAll && (
      <StyledTileMore
        onClick={() => {
          if (tileData?.itemType !== 'category') {
            setSelectedCategory(true)
          }
        }}
      >
        {'More >'}
      </StyledTileMore>
    )
  )
}

const Tile = (props) => {
  const [selectedCategory, setSelectedCategory] = useState(false)
  const { tileData, userData, tileId, policyId, tilePolicyId, isOnBackground } = props

  return (
    <StyledTileContainer isOnBackground={isOnBackground}>
      {(isOnBackground && tileData?.itemType === 'dailyFeature') ||
      tileData?.itemType === 'dailyQuote' ||
      tileData?.categoryType === 'tutorial' ? null : (
        <StyledTileHeader>
          {renderTitle(tileData, setSelectedCategory)}
          {renderMore(tileData, setSelectedCategory)}
          {selectedCategory && (
            <BrowseByCategory
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              categoryList={tileData?.items}
              cardsType={tileData?.itemType}
              tileId={tileId}
              policyId={policyId}
              cardsCategory={tileData?.categoryType}
              tilePolicyId={tilePolicyId}
              //extras because of new format:
              categoryHeader={tileData?.title || tileData?.altText}
              fromMore
            />
          )}
        </StyledTileHeader>
      )}

      <CardList
        cardsData={tileData?.items}
        cardsType={tileData?.itemType}
        cardsCategory={tileData?.categoryType}
        cardsLayout={tileData?.layout}
        userData={userData}
        tileId={tileId}
        policyId={policyId}
        tilePolicyId={tilePolicyId}
        extraData={
          tileData?.itemType === 'dailyFeature' && tileData?.allDailyFeatures
            ? tileData?.allDailyFeatures?.items
            : null
        }
      />
    </StyledTileContainer>
  )
}

export default Tile
